import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common-services/common.service';
import { environment } from 'src/environments/environment';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-industry-dialog',
  templateUrl: './industry-dialog.component.html',
  styleUrls: ['./industry-dialog.component.scss']
})
export class IndustryDialogComponent {
  activeItem: any;
  baseUrl = environment.BASE_URL;
  industryData: any[] = [];
  // constructor(private service: CommonService, private dialogRef: MatDialogRef<IndustryDialogComponent>,private fb: FormBuilder){ 
  // }

  interestsList: any[] = [];
  industryList: any[] = [];
  clickedIndustry: any = 0;

  constructor(private dialogRef: MatDialogRef<IndustryDialogComponent>, private service: CommonService, @Inject(MAT_DIALOG_DATA) public data: any) { }

  closeDialog(isTrue: Boolean) {
    this.dialogRef.close({ isTrue: isTrue, data: this.industryList });
  }
  ngOnInit() {
    if (this.data) {
      this.industryList = this.data.data;
    }
  }

  isActive(i: any): boolean {
    return this.activeItem === i;
  }
  
  toggleValueCheckIndustry(ev: any, sector: any) {
    sector.isChecked = ev.target.checked
  }
  clickIndustry(index: any) {
    this.clickedIndustry = index;
    this.activeItem = index;
  }
  isIndustryChecked(index: any) {
    let isChecked = false;
    this.industryList[index].sectors.forEach((sector: any) => {
      if (sector.isChecked) {
        isChecked = true
      }
    })
    return isChecked;
  }

  // ngOnInit(){
  //  // this.getIndustry();
  // }



  // getIndustry() {
  //   this.service.getData(`${this.baseUrl}common-service/industry-management`).subscribe((res: any) => {
  //     this.industryData = res?.response;
  //   })
  // }

  // closeDialog(isTrue: Boolean) {
  //   this.dialogRef.close();
  // }
  // onSave(){
  //   // alert("hello");
  // }


}
